<template>
  <span class="codespan">
    <slot>code simple</slot>
  </span>
</template>

<script>
export default {
  name: "codesimple",
  mixins: [],
  created() {},
  data: () => ({}),
  components: {},
  props: {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style>
.codespan {
  color: #c0341d;
  background-color: #fbe5e1;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
